import { useHead } from '@unhead/react'
import { Navigate } from 'react-router-dom'

const BASE_URL = 'https://bnssa-mns.fr'

interface RedirectWithCanonicalProps {
  /** Chemin cible de la redirection (ex: "/offres") */
  to: string
  /** Conserve l'historique ? Par défaut replace=true (équivalent 301) */
  replace?: boolean
}

/**
 * Redirection client-side "SEO-friendly" pour la SPA Emplois BNSSA & MNS.
 *
 * Contexte : l'app est une SPA Vite/React Router servie en statique — il n'y a pas
 * de serveur applicatif pour émettre un vrai HTTP 301. Ce composant émet donc, avant
 * la redirection, un <link rel="canonical"> + une meta robots vers l'URL cible, ce qui
 * constitue le meilleur substitut SEO disponible (consolidation du jus de lien par Google)
 * tout en effectuant la navigation via <Navigate replace> (équivalent fonctionnel d'un 301).
 *
 * Pour un VRAI 301 au niveau HTTP, une règle de redirection doit être configurée
 * côté hébergeur/CDN (réglages de domaine), hors périmètre du code applicatif.
 */
export default function RedirectWithCanonical({ to, replace = true }: RedirectWithCanonicalProps) {
  const canonicalHref = to.startsWith('http') ? to : `${BASE_URL}${to}`

  useHead({
    link: [{ rel: 'canonical', href: canonicalHref }],
    meta: [{ name: 'robots', content: 'noindex, follow' }],
  })

  return <Navigate to={to} replace={replace} />
}
